import { render, staticRenderFns } from "./DeviceBlock.vue?vue&type=template&id=60271f34&"
import script from "./DeviceBlock.vue?vue&type=script&lang=js&"
export * from "./DeviceBlock.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBlock.vue?vue&type=style&index=0&id=60271f34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports